var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSorrisos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 56,
    viewBox: "0 0 128 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4696 33.3364C17.5292 38.0209 22.635 41.3334 27.9989 41.3334C33.34 41.3334 38.436 38.0124 40.5134 33.3481",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 22.6666C21.4728 22.6666 22.6667 21.4727 22.6667 20C22.6667 18.5272 21.4728 17.3333 20 17.3333C18.5273 17.3333 17.3333 18.5272 17.3333 20C17.3333 21.4727 18.5273 22.6666 20 22.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 22.6666C37.4728 22.6666 38.6667 21.4727 38.6667 20C38.6667 18.5272 37.4728 17.3333 36 17.3333C34.5273 17.3333 33.3333 18.5272 33.3333 20C33.3333 21.4727 34.5273 22.6666 36 22.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 54.6666C42.7276 54.6666 54.6667 42.7276 54.6667 28C54.6667 13.2724 42.7276 1.33331 28 1.33331C13.2724 1.33331 1.33334 13.2724 1.33334 28C1.33334 42.7276 13.2724 54.6666 28 54.6666Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 22.6666C93.4728 22.6666 94.6667 21.4727 94.6667 20C94.6667 18.5272 93.4728 17.3333 92 17.3333C90.5273 17.3333 89.3333 18.5272 89.3333 20C89.3333 21.4727 90.5273 22.6666 92 22.6666Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108 22.6666C109.473 22.6666 110.667 21.4727 110.667 20C110.667 18.5272 109.473 17.3333 108 17.3333C106.527 17.3333 105.333 18.5272 105.333 20C105.333 21.4727 106.527 22.6666 108 22.6666Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M89.3333 38.6666C89.3333 38.6666 94.6667 36 99.9915 36.003C105.333 36 110.667 38.6666 110.667 38.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 54.6666C114.728 54.6666 126.667 42.7276 126.667 28C126.667 13.2724 114.728 1.33331 100 1.33331C85.2724 1.33331 73.3333 13.2724 73.3333 28C73.3333 42.7276 85.2724 54.6666 100 54.6666Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSorrisos);
export default __webpack_public_path__ + "static/media/ico-sorrisos.afee759aadf969006bb697cad14c6a28.svg";
export { ForwardRef as ReactComponent };